import React from 'react';
// import PropTypes from 'prop-types';
import { StyledChartToolTip } from './ChartToolTip.styles';
export const ChartToolTip = (props) => {
    const { children, className, id, xPos, yPos } = props;
    return (React.createElement(StyledChartToolTip, { className: className, "data-cy": props['data-cy'], id: id, style: { top: yPos, left: xPos } },
        React.createElement("div", { className: "Tooltip-Contents" }, children)));
};
// ChartToolTip.propTypes = {
//     xPos: PropTypes.number.isRequired,
//     yPos: PropTypes.number.isRequired
// };
//# sourceMappingURL=ChartToolTip.js.map